/**
 * Logos da Berytus Conecta (arquivos oficiais em public/brand, do design system).
 * Regras da marca: não recriar o wordmark com fonte, não recolorir, colorido só sobre navy-900,
 * branco ou mist-50; horizontal com no mínimo 120 px de largura.
 * berytus-horizontal-dark-transparent.svg é a versão dark oficial sem o retângulo de fundo,
 * para assentar sobre a faixa do tema escuro (navy-950).
 */

/** Logo da faixa superior: horizontal sobre navy-900; no celular, só o símbolo. */
export function BandLogo() {
  return (
    <>
      <img className="full" src="/brand/berytus-horizontal-dark-transparent.svg" alt="Berytus Conecta" width={148} height={52} />
      <img className="mark" src="/brand/berytus-simbolo-color.svg" alt="Berytus Conecta" width={24} height={30} />
    </>
  );
}

/** Logo da tela de login, sobre o fundo navy-900. */
export function LoginLogo() {
  return <img className="login-logo" src="/brand/berytus-horizontal-dark.svg" alt="Berytus Conecta" width={300} height={105} />;
}
